import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { PROCESS } from './processConfig';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipRefetch?: boolean;
  }
}

export const api = axios.create({ baseURL: PROCESS.ENV.API });

export async function mutator<T>(config: AxiosRequestConfig, options?: AxiosRequestConfig) {
  return api<T>({ ...config, ...options }).then(({ data }) => data);
}

api.interceptors.request.use(async (config) => {
  const token = sessionStorage.getItem('access');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    handleErrorResponse(error);
    //return Promise.reject(error);
  },
);

async function handleErrorResponse(error: any) {
  const errorResponse = error.response?.data;
  const statusCode = errorResponse?.code ?? errorResponse?.statusCode ?? 400;

  if (statusCode === 401) {
    sessionStorage.removeItem('access');
  }
}

export type ErrorType<Error> = AxiosError<Error>;
